<template>
<div>
    <Breadcrumbs main="Admin" title="Gallery" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Gallery</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">

                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="gallery_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <img :src="host+row.item.image" alt="" style="height: 80px;">
                                    </template>
                                    <template #cell(type)="row">
                                        <div v-if="row.item.type">
                                            <p v-if="row.item.type === 'campaign'">Campaign</p>
                                            <p v-if="row.item.type === 'law_n_policy'">Law & Policy</p>
                                            <p v-if="row.item.type === 'news'">News</p>
                                        </div>
                                    </template>

                                    

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">

                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteGallery(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editGallery(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader/>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Gallery Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Gallery" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control digits" v-model="gallery.type">
                            <option v-for="(type, index) in galleryType" :key="index" :value="type.value">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" v-if="gallery.type">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label v-if="gallery.type === 'campaign'">Campaign</label>
                        <label v-if="gallery.type === 'law_n_policy'">Law & Policy</label>
                        <label v-if="gallery.type === 'news'">News</label>
                        <select class="form-control digits" v-model="gallery.type_id">
                            <option v-for="(type, index) in typeList" :key="index.id" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image (Ratio 1:1)</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="width: 120px; height: 80px;" :src="show_image">
                            <input :class="gallery.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadFile">
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Gallery Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Gallery" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control digits" v-model="edit_gallery.type">
                            <option v-for="(type, index) in galleryType" :key="index" :value="type.value">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" v-if="edit_gallery.type">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label v-if="edit_gallery.type === 'campaign'">Campaign</label>
                        <label v-if="edit_gallery.type === 'law_n_policy'">Law & Policy</label>
                        <label v-if="edit_gallery.type === 'news'">News</label>
                        <select class="form-control digits" v-model="edit_gallery.type_id">
                            <option v-for="(type, index) in typeList" :key="index.id" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image (Ratio 1:1)</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="width: 120px; height: 80px;" :src="show_image">
                            <input :class="edit_gallery.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="EdituploadFile">
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </b-modal>
    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this gallery?</div>
    </b-modal>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host'
import js from '../../../auth/js';
import loader from '../loader/loader.vue'
export default {
    components: {
        Datepicker,
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true
                },
               
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            galleryType: [
                {
                    name:'Campaign',
                    value:'campaign'
                },
                {
                    name:'Press Release',
                    value:'press_release'
                },
               
                {
                    name:'News',
                    value:'news'
                }
             
            ],

            gallery: {
                type: '',
                type_id: '',
                image: '',

            },

            edit_gallery: {
                id:'',
                type: '',
                type_id: '',
                image: '',

            },
            show_image: null,

            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],

            temp_quotation: {}
        };
    },

    computed: {
        ...mapState({
            gallery_list: state => state.gallery.galleries,
            loading: state => state.gallery.galleryLoading,
            error: state => state.gallery.galleryError,
            campaignList: state => state.campaign.campaigns,
            lawList: state => state.law.laws,
            newsList: state => state.news.news,
            pressList: state => state.press.pressReleases

        }),
        typeList() {
            switch (this.gallery.type || this.edit_gallery.type) {
                case 'campaign':
                    return this.campaignList;
                case 'law_n_policy':
                    return this.lawList;
                case 'news':
                    return this.newsList;
                case 'press_release':
                    return this.pressList;
                default:
                    return [];
            }
        },

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },

    },

    mounted() {
        this.$store.dispatch("gallery/fetchGallery").then(() => {
            this.items = this.gallery_list
            this.totalRows = this.items.length;
        });
        this.$store.dispatch("campaign/fetchCampaign");
        this.$store.dispatch("law/fetchLaw");
        this.$store.dispatch("news/fetchNews");
        this.$store.dispatch("press/fetchPress")
    },

    methods: {
        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.gallery.image = e.target.result;
                this.edit_gallery.image = e.target.result;
            };
        },
        EdituploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.edit_gallery.image = e.target.result;
            };
        },
        onFiltered(filteredItems) {

            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.department.name = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()

        },

        handleSubmit() {

            this.$store.dispatch("gallery/addGallery", {
                gallery: this.gallery
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.gallery.type = null,
                    this.gallery.type_id = null
                    this.gallery.image = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editGallery(detail) {
           
            this.edit_gallery.id =  detail.id? detail.id : null
            this.edit_gallery.type = detail.type ?detail.type : null
            this.edit_gallery.type_id = detail.type_id? detail.type_id : null
            this.show_image = detail.image ? this.host + detail.image : null

        },

        resetEditModal() {
            this.edit_gallery.id =   null
            this.edit_gallery.type =  null
            this.edit_gallery.type_id = null
            this.show_image = null

        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {

            this.$store.dispatch("gallery/updateGallery", {
                id: this.edit_gallery.id,
                gallery: this.edit_gallery,

            }).then(response => {
                
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.edit_gallery.id = ''
                    this.edit_gallery.type = ''
                    this.edit_gallery.type_id = ''
                    this.edit_gallery.image = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },
        deleteGallery(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("gallery/deleteGallery", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
